import React from 'react';
import PropTypes from 'prop-types';
import api from 'api';
import Component from 'BaseComponent';
import { notice, alert } from 'ducks/notifications';
import { reduxForm } from 'redux-form';
import convertToFormErrors from 'utils/convertToFormErrors';
import { withRouter } from 'react-router-dom';
import Field from 'form/Field';
import Form from 'form/Form';
import { connect } from 'react-redux';
import SubmitButton from 'form/SubmitButton';

@withRouter

@connect((state, props) => ({
  initialValues: props.site.attributes,
}))

@reduxForm({
  form: 'DeploySettings',
  onSubmit(values, dispatch, props) {
    const { site } = props;

    return dispatch(api.updateSite(
      { id: site.id },
      {
        data: {
          type: 'site',
          attributes: values,
        },
      },
    ))
    .then(() => {
      props.history.push(`/site/${site.id}/settings`);
      dispatch(notice('Settings.success'));
    })
    .catch((response) => {
      dispatch(alert('DeploySettings.error'));
      return Promise.reject(convertToFormErrors(response));
    });
  },
})

export default class DeploySettings extends Component {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    error: PropTypes.string,
  }

  render() {
    const { handleSubmit, submitting, error, dirty } = this.props;

    return (
      <div className="Site__area">
        <div className="Site__area__header">
          <div className="Site__area__header__title">
            Deploy settings
          </div>
        </div>
        <div className="Site__area__content">
          <Form error={error} onSubmit={handleSubmit}>
            <Field label="Settings.additionalFiles" name="additionalFiles" placeholder="/images/image1.png&#10;/sitemap.xml">
              <textarea rows="4" />
            </Field>
            <Field label="Settings.excludedFiles" name="excludedFiles" placeholder="/wp-content/uploads/secret-image.png&#10;/data/secret.txt">
              <textarea rows="4" />
            </Field>
            <SubmitButton
              dirty={dirty}
              className="button button--secondary"
              submitting={submitting}
              label="Settings.submit"
            />
          </Form>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/DeploySettings.jsx